import { Explainer } from "@/components/ui/Explainer";

/** The explainer the design offers beside the panel heading. */
export function WhatIsAPosition() {
  return (
    <Explainer label="What is a Position?" testId="position-why">
      <p>
        A position is a distinct argument for why the invention is novel: a
        self-contained inventive step, mapped to the invention elements it rests
        on. Each one is checked independently against every prior art document
        in the library.
      </p>
      <p>
        A position is not the same as a claim. A <b>position</b> captures the
        novelty of exactly what has been invented; a <b>claim</b> is a broader
        interpretation of a position, worded to maximise the coverage of the
        patent. Positions come first. Claims are drafted from them later in
        Claim Strategy.
      </p>
      <p>
        Draft your own, or have them generated. Amend or drop each position,
        then run the novelty analysis. Only the positions you confirm in the
        analysis carry forward into Claim Strategy.
      </p>
    </Explainer>
  );
}
